import { z } from 'zod';
import { c } from '../contract';
import {
  readingListSearchResponse,
  readingListFollowedResponse,
  readingListStoriesResponse,
  readingListDiscoveryResponse,
} from '../schemas/reading-lists.schema';

export const readingListsRouter = c.router(
  {
    search: {
      summary: 'Search Reading Lists',
      method: 'GET',
      path: '/search',
      query: z.object({
        query: z.string().optional(),
        page_size: z.number().int().min(1).max(30).optional(),
        page_number: z.number().optional(),
        language: z.string().optional(),
        tag_slugs: z.string().optional(),
        type: z.string().optional(),
        is_web_indexable: z.boolean().optional(),
      }),
      responses: {
        500: z.object({ error: z.string() }),
        200: readingListSearchResponse,
      },
    },
    stories: {
      summary: 'Get Reading List Stories',
      method: 'GET',
      path: '/:listId/stories',
      query: z.object({
        page: z.number().optional(),
        items_per_page: z.number().int().min(1).max(30).optional(),
        language: z.string().optional(),
      }),
      responses: {
        500: z.object({ error: z.string() }),
        200: readingListStoriesResponse,
      },
    },
    follow: {
      summary: 'Follow Reading List',
      method: 'POST',
      path: '/:listId/follow',
      body: z.object({}),
      responses: {
        500: z.object({ error: z.string() }),
        200: z.object({ message: z.string() }),
      },
    },
    unfollow: {
      summary: 'Unfollow Reading List',
      method: 'DELETE',
      path: '/:listId/unfollow',
      body: z.object({}),
      responses: {
        500: z.object({ error: z.string() }),
        200: z.object({ message: z.string() }),
      },
    },
    followed: {
      summary: 'Get Followed Reading Lists',
      method: 'GET',
      path: '/followed',
      query: z.object({
        type: z.string().optional(),
        page: z.number().optional(),
        items_per_page: z.number().optional(),
        sort: z.string().optional(),
      }),
      responses: {
        500: z.object({ error: z.string() }),
        200: readingListFollowedResponse,
      },
    },
    discovery: {
      summary: 'Get Reading Lists Discovery',
      method: 'GET',
      path: '/discovery',
      query: z.object({
        language: z.string().optional(),
        kind: z.string().optional(),
        page: z.number().optional(),
        items_per_page: z.number().int().min(1).max(30).optional(),
      }),
      responses: {
        500: z.object({ error: z.string() }),
        200: readingListDiscoveryResponse,
      },
    },
  },
  { pathPrefix: '/reading-lists' },
);
